import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { SsoCallbackComponent } from './pages/sso-callback/sso-callback.component';
import { RouteGuardsService } from './services/core/route-guards.service';
import { BlankComponent } from './components/blank/blank.component';
import { ADMIN_ID_ROLE_LIST } from './shared/constants/roles.constants';
import { FlaggedPreloadingStrategy } from './services/core/flagged-preloading.strategy';

export const routes: Routes = [
  { path: '', redirectTo: 'map', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'sso-callback', component: SsoCallbackComponent },
  {
    path: 'loading',
    loadComponent: () =>
      import('./pages/loading/loading.component').then((m) => m.PanteraLoadingComponent),
  },
  {
    path: 'map',
    canActivate: [RouteGuardsService],
    data: { preload: true },
    loadComponent: () => import('./map/map.component').then((m) => m.MapComponent),
  },
  {
    path: 'map-p3',
    canActivate: [RouteGuardsService],
    data: { roles: ADMIN_ID_ROLE_LIST },
    loadComponent: () => import('./map-p3/map-p3.component').then((m) => m.MapP3Component),
  },
  {
    path: 'interface',
    canActivate: [RouteGuardsService],
    loadChildren: () => import('./interface-p3/interface.module').then((m) => m.InterfaceModule),
  },
  {
    path: 'interface-p3',
    canActivate: [RouteGuardsService],
    loadChildren: () => import('./interface-p3/interface.module').then((m) => m.InterfaceModule),
  },
  {
    path: 'admin',
    canActivate: [RouteGuardsService],
    data: { roles: ADMIN_ID_ROLE_LIST },
    loadComponent: () => import('./pages/admin/admin.component').then((m) => m.AdminComponent),
  },
  {
    path: 'geo-uploader',
    canActivate: [RouteGuardsService],
    data: { roles: ADMIN_ID_ROLE_LIST },
    loadComponent: () =>
      import('./pages/geo-uploader/geo-uploader/geo-uploader.component').then(
        (m) => m.GeoUploaderComponent
      ),
  },
  {
    path: 'smart-label',
    canActivate: [RouteGuardsService],
    data: { roles: ADMIN_ID_ROLE_LIST },
    loadComponent: () =>
      import('./pages/smart-label/label.component').then((m) => m.LabelComponent),
  },
  { path: 'home', component: BlankComponent, canActivate: [RouteGuardsService] },
  {
    path: 'mosaic',
    canActivate: [RouteGuardsService],
    loadChildren: () => import('./pages/mosaic/mosaic.module').then((m) => m.MosaicModule),
  },
  {
    path: 'report/:idReport',
    canActivate: [RouteGuardsService],
    loadChildren: () =>
      import('./pages/report-standalone/report-standalone.module').then(
        (m) => m.ReportStandaloneModule
      ),
  },
  {
    path: 'report-public/:token',
    loadChildren: () =>
      import('./pages/report-standalone/report-standalone.module').then(
        (m) => m.ReportStandaloneModule
      ),
  },
  { path: '**', redirectTo: 'map' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      onSameUrlNavigation: 'reload',
      preloadingStrategy: FlaggedPreloadingStrategy,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
